export default "__VITE_ASSET__0pIQpRRR__"